import ArtistProfile1 from "./previews/ArtistProfile1";
import ArtistProfile2 from "./previews/ArtistProfile2";
import ArtistProfile3 from "./previews/ArtistProfile3";
import ArtistProfile4 from "./previews/ArtistProfile4";

export default function ProjectPreviews() {
  return (
    <div>
      <ArtistProfile1 />
      <ArtistProfile2 />
      <ArtistProfile3 />
      <ArtistProfile4 />
    </div>
  );
}